// extracted by mini-css-extract-plugin
export default {"melodyVideo":"gJ-z","isFullWidth":"hJ-z","landingPageVideo":"iJ-z","play":"jJ-z","iframeVideo":"kJ-z","playHidden":"lJ-z","fullwidth":"mJ-z"};